import { render, staticRenderFns } from "./WhatsappActionForm.vue?vue&type=template&id=21175748&scoped=true"
import script from "./WhatsappActionForm.vue?vue&type=script&lang=js"
export * from "./WhatsappActionForm.vue?vue&type=script&lang=js"
import style0 from "./WhatsappActionForm.vue?vue&type=style&index=0&id=21175748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21175748",
  null
  
)

export default component.exports